<ion-app *ngIf="globalData.isMobileStyle; else isWeb">
  <ion-split-pane contentId="main-content" [when]="false">
    <app-sidebar *ngIf="authService.isLoggedIn()"></app-sidebar>

    <!-- Offline banner -->
    <ng-container *ngIf="!(networkServ.isConnected$() | async)">
      <div class="offline-banner"> <i class="bi bi-cloud-slash"></i> {{ 'label.noInternet' | i18n }} </div>
    </ng-container>

    <ion-router-outlet
      [animated]="false"
      id="main-content"
      [ngClass]="{ 'is-offline': !(networkServ.isConnected$() | async) }"
    ></ion-router-outlet>
  </ion-split-pane>
</ion-app>

<ng-template #isWeb>
  <router-outlet></router-outlet>
</ng-template>
